import {Module, VuexModule, Mutation, Action, getModule, MutationAction} from 'vuex-module-decorators';
import store from '@/model/store/store';
import api from '@/model/api';
import {UserDataOnSessionStorageDataInterface, UserDataOnSessionStorageInterface} from '@/model/interfaces/user-interface';
import {GULUserRes, GetUserListRes} from '@/model/dto/res/user/get-user-list-res';
import {PUUDataReq, PostUpsertUserReq} from '@/model/dto/req/user/post-upsert-user-req';
import userService from '@/model/services/user-service';

@Module({dynamic: true, store, namespaced: true, name: 'userModule'})
class UserModule extends VuexModule {

  private strageData: UserDataOnSessionStorageInterface = JSON.parse(sessionStorage.getItem('undeux') || '{}');
  // States
  public userId: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.userModule.userId : ''; // ユーザー名
  public userName: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.userModule.userName : ''; // ユーザー名
  public type: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.userModule.type : ''; // ユーザータイプ
  public apiToken: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.userModule.apiToken : ''; // CSRFのToken名
  public csrfToken: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.userModule.csrfToken : ''; // CSRFトークン
  public tokenExpire: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.userModule.tokenExpire : ''; // トークン期限日
  public isStrage: boolean = false;
  public userInfo: GULUserRes[] = [];
  public upsertStatus: number = 0;
  public isUsersFormDialog: boolean = false;
  public selectUserInfo: GULUserRes = {
    user_name: '',
    type: '',
    password: '',
    email: ''
  };

  // Mutations
  @Mutation
  private setUserId(userId: string): void {
    this.userId = userId;
  }

  @Mutation
  private setName(name: string): void {
    this.userName = name;
  }

  @Mutation
  private setType(type: string): void {
    this.type = type;
  }

  @Mutation
  private setApiToken(apiToken: string): void {
    this.apiToken = apiToken;
  }

  @Mutation
  private setCSRFToken(csrfToken: string): void {
    this.csrfToken = csrfToken;
  }

  @Mutation
  private setTokenExpire(tokenExpire: string): void {
    this.tokenExpire = tokenExpire;
  }

  @Mutation
  private setSelectUserInfo(param: GULUserRes): void {
    this.selectUserInfo = param;
  }

  @Mutation
  private setSelectUserInfoName(str: string): void {
    this.selectUserInfo.user_name = str;
  }

  @Mutation
  private setSelectUserInfoType(str: string): void {
    this.selectUserInfo.type = str;
  }

  @Mutation
  private setSelectUserInfoMail(str: string): void {
    this.selectUserInfo.email = str;
  }

  @Mutation
  private setSelectUserInfoPassword(str: string): void {
    this.selectUserInfo.password = str;
  }

  @Mutation
  private setClearStrage(): void {
    this.tokenExpire = '';
    this.csrfToken = '';
    this.apiToken = '';
    this.type = '';
    this.userName = '';
    this.userId = '';
  }

  @Mutation
  private setIsStrage(state: boolean): void {
    this.isStrage = state;
  }

  @Mutation
  private setIsUsersFormDialog(state: boolean): void {
    this.isUsersFormDialog = state;
  }

  // Actions
  @Action
  public clearStrage(): void {
    this.setClearStrage();
  }

  @Action
  public updateIsStrage(state: boolean): void {
    this.setIsStrage(state);
  }

  @Action
  public updateIsUsersFormDialog(state: boolean): void {
    this.setIsUsersFormDialog(state);
  }

  @Action
  public updateSelectUserInfo(param: GULUserRes): void {
    this.setSelectUserInfo(param);
  }

  @Action
  public updateSelectUserInfoName(str: string): void {
    this.setSelectUserInfoName(str);
  }

  @Action
  public updateSelectUserInfoType(str: string): void {
    this.setSelectUserInfoType(str);
  }

  @Action
  public updateSelectUserInfoMail(str: string): void {
    this.setSelectUserInfoMail(str);
  }

  @Action
  public updateSelectUserInfoPassword(str: string): void {
    this.setSelectUserInfoPassword(str);
  }

  /**
   * ユーザー情報をリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUserInfo(): Promise<any> {
    try {
      const res = await api.getUserInfo();
      return {
        userId: res.results.user_id,
        userName: res.results.user_name,
        type: res.results.type,
        apiToken: res.results.apiToken,
        csrfToken: res.results.csrfToken,
        tokenExpire: res.results.tokenExpire
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * コンテンツ情報をリクエスト
   *
   * TODO:
   */
  @MutationAction({ rawError: true })
  public async requestUserListInfo(id?: string): Promise<any> {
    try {
      const info = await api.getUserListInfo(id);
      return {
        userInfo: info.results
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * メモ情報追加をリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUpsertUserInfo(
    param: PUUDataReq
  ): Promise<any> {
    try {
      const data = await api.postUpsertUserInfo(param);
      let status: number = data?.results.status ?? 0;
      if (status === 0) { status = Math.floor( Math.random() * 101 ); }
      return {
        upsertStatus: status
      };
    } catch (err) {
      throw err;
    }
  }
}

export default getModule(UserModule, store);
